import { render, staticRenderFns } from "./ServiceMultiPointAdditional.vue?vue&type=template&id=20235bab&scoped=true&"
import script from "./ServiceMultiPointAdditional.vue?vue&type=script&lang=js&"
export * from "./ServiceMultiPointAdditional.vue?vue&type=script&lang=js&"
import style0 from "./ServiceMultiPointAdditional.vue?vue&type=style&index=0&id=20235bab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20235bab",
  null
  
)

export default component.exports